(() => {
  const pendingRows = new Map();
  let rowsFrame = null;
  const scheduleRow = (row, measure) => {
    pendingRows.set(row, measure);
    if (rowsFrame !== null) return;
    rowsFrame = requestAnimationFrame(() => {
      rowsFrame = null;
      const updates = [...pendingRows].filter(([row]) => row.isConnected).map(([, read]) => read());
      pendingRows.clear();
      updates.forEach((write) => write());
    });
  };
  if (!customElements.get("pb-footmuff-models")) {
    customElements.define("pb-footmuff-models", class extends HTMLElement {
      connectedCallback() {
        var _a;
        (_a = this.abort) == null ? void 0 : _a.abort();
        clearTimeout(this.scrollTimer);
        this.abort = new AbortController();
        const links = [...this.querySelectorAll(".pb-fm__nav a")];
        const rows = [...this.querySelectorAll("pb-footmuff-row")];
        if (this.hasAttribute("data-model-grid")) {
          const requested = new URL(window.location.href).searchParams.get("pb_model");
          const chosen = rows.find((row) => row.dataset.model === requested);
          this.classList.toggle("pb-fm--model-grid", Boolean(chosen));
          rows.forEach((row) => row.hidden = Boolean(chosen) && row !== chosen);
          const back = this.querySelector(".pb-fm__back");
          if (back) back.hidden = !chosen;
          if (chosen) return;
        }
        if (!links.length || !rows.length) return;
        const select = (id) => links.forEach((link) => {
          if (link.hash === "#" + id) {
            if (link.getAttribute("aria-current") !== "location") link.setAttribute("aria-current", "location");
          } else if (link.hasAttribute("aria-current")) link.removeAttribute("aria-current");
        });
        const syncScroll = () => {
          const threshold = Math.max(140, window.innerHeight * 0.3);
          let current = rows[0];
          for (const row of rows) {
            if (row.getBoundingClientRect().top <= threshold) current = row;
            else break;
          }
          select(current.id);
        };
        const syncHash = () => {
          const target = rows.find((row) => "#" + row.id === window.location.hash);
          if (target) select(target.id);
          else syncScroll();
        };
        const schedule = () => {
          clearTimeout(this.scrollTimer);
          this.scrollTimer = setTimeout(syncScroll, 140);
        };
        links.forEach((link) => link.addEventListener("click", (event) => {
          if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          clearTimeout(this.scrollTimer);
          select(link.hash.slice(1));
        }, { signal: this.abort.signal }));
        window.addEventListener("hashchange", syncHash, { signal: this.abort.signal });
        window.addEventListener("scroll", schedule, { capture: true, passive: true, signal: this.abort.signal });
        window.addEventListener("resize", schedule, { passive: true, signal: this.abort.signal });
        window.addEventListener("pageshow", syncHash, { signal: this.abort.signal });
        syncHash();
      }
      disconnectedCallback() {
        var _a;
        (_a = this.abort) == null ? void 0 : _a.abort();
        clearTimeout(this.scrollTimer);
      }
    });
  }
  if (!customElements.get("pb-footmuff-row")) {
    customElements.define("pb-footmuff-row", class extends HTMLElement {
      connectedCallback() {
        var _a, _b;
        (_a = this.abort) == null ? void 0 : _a.abort();
        (_b = this.observer) == null ? void 0 : _b.disconnect();
        this.abort = new AbortController();
        const track = this.querySelector(".pb-fm__track"), buttons = [...this.querySelectorAll("[data-direction]")];
        if (!track || buttons.length < 2) return;
        const isRtl = () => getComputedStyle(track).direction === "rtl";
        const measure = () => {
          const max = track.scrollWidth - track.clientWidth;
          const position = isRtl() ? -track.scrollLeft : track.scrollLeft;
          const previousDisabled = position <= 2;
          const nextDisabled = position >= max - 2;
          return () => {
            if (buttons[0].disabled !== previousDisabled) buttons[0].disabled = previousDisabled;
            if (buttons[1].disabled !== nextDisabled) buttons[1].disabled = nextDisabled;
          };
        };
        const sync = () => scheduleRow(this, measure);
        buttons.forEach((button) => button.addEventListener("click", () => {
          track.scrollBy({ left: Number(button.dataset.direction) * (isRtl() ? -1 : 1) * track.clientWidth * 0.85, behavior: matchMedia("(prefers-reduced-motion: reduce)").matches ? "instant" : "smooth" });
        }, { signal: this.abort.signal }));
        track.addEventListener("scroll", sync, { passive: true, signal: this.abort.signal });
        this.observer = new ResizeObserver(sync);
        this.observer.observe(track);
        this.setAttribute("data-ready", "");
        sync();
      }
      disconnectedCallback() {
        var _a, _b;
        (_a = this.abort) == null ? void 0 : _a.abort();
        (_b = this.observer) == null ? void 0 : _b.disconnect();
        pendingRows.delete(this);
        if (!pendingRows.size && rowsFrame !== null) {
          cancelAnimationFrame(rowsFrame);
          rowsFrame = null;
        }
      }
    });
  }
})();
